import { UseApi } from '../utils/axios-pettitions';

export async function getGanancias() {
  try {
    const { runApi } = UseApi();
    const response = await runApi('ganancias', 'GET');
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al obtener los resumenes',
    };
  }
}

export async function getGananciasById(id: number) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('ganancias', 'GET', { id });
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al obtener la lista de resumenes de ganancias',
    };
  }
}

export async function createGanancias(Ganancias: any) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('ganancias', 'POST', null, Ganancias);
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al crear las ordenes de compra',
    };
  }
}

export async function updateGanacias(id: number, Ganancias: any) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('ganancias', 'PUT', { id }, Ganancias);
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al actualizar las ganancias',
    };
  }
}

export async function deleteGanancias(id: number) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('ganancias', 'DELETE', { id });
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al eliminar la lista de resumenes de ganancias',
    };
  }
}